import { ChevronDown } from 'lucide-react';
import { chatPageService } from '../../../services/index.js';

export const ModelDropdownTrigger = ({ selectedModel, isOpen, onClick }) => (
  <button
    onClick={onClick}
    className="flex items-center gap-1.5 px-3.5 h-9 rounded-full hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors"
  >
    <span className="text-sm font-semibold text-slate-700 dark:text-slate-200 whitespace-nowrap">
      {selectedModel?.modelGroupName ?? 'Select Model'}
    </span>
    <ChevronDown
      size={14}
      className={`text-slate-400 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
    />
  </button>
);

export const ModelDropdownList = ({ models, selectedModel, setSelectedModel, setIsOpen, conversationId }) => (
  <div className="absolute right-0 top-full mt-2 w-52 bg-white dark:bg-slate-800 rounded-2xl shadow-xl border border-slate-200/80 dark:border-slate-700 py-1.5 z-[102] animate-in fade-in zoom-in-95 duration-150 origin-top-right overflow-hidden">
    {models.map(model => (
      <button
        key={model.modelGroupId}
        onClick={() => {
          setSelectedModel(model);
          setIsOpen(false);
          if (conversationId) {
            chatPageService.updateConversationModelGroup(conversationId, model.modelGroupId)
              .catch(err => console.error('updateConversationModelGroup error:', err));
          }
        }}
        className="w-full text-left px-4 py-2.5 text-sm hover:bg-slate-50 dark:hover:bg-slate-700/50 transition-colors flex items-center justify-between"
      >
        <span className={selectedModel?.modelGroupId === model.modelGroupId ? 'text-[#1d57a5] dark:text-[#4a8ce3] font-semibold' : 'text-slate-700 dark:text-slate-200'}>
          {model.modelGroupName || `Model Group ${model.modelGroupId}`}
        </span>
        {selectedModel?.modelGroupId === model.modelGroupId && <div className="w-2 h-2 rounded-full bg-[#36a852]" />}
      </button>
    ))}
  </div>
);

export const ModelDropdown = ({ selectedModel, setSelectedModel, isOpen, setIsOpen, models = [], conversationId }) => (
  <div className="relative z-10">
    <ModelDropdownTrigger selectedModel={selectedModel} isOpen={isOpen} onClick={() => setIsOpen(!isOpen)} />
    {isOpen && <ModelDropdownList models={models} selectedModel={selectedModel} setSelectedModel={setSelectedModel} setIsOpen={setIsOpen} conversationId={conversationId} />}
  </div>
);